import React from 'react';
import OrderGroupList from './OrderGroupList';
import NoOrdersFound from './NoOrdersFound';

export default props => (
  <div className="mt-4">
    <h2 className="h4">{props.title}</h2>
    <p>{props.description}</p>
    {props.orders.length ? (
      <OrderGroupList orders={props.orders} />
    ) : (
      <NoOrdersFound />
    )}
  </div>
);



// WEBPACK FOOTER //
// ./src/components/orders/OrderGroup.js